import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useGlobalContext } from "../GlobalContext";

const SetPotSukarela = () => {
  const { api, isReady } = useGlobalContext();
  const [dataPotongan, setDataPotongan] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [modalAddOpen, setModalAddOpen] = useState(false);
  const [modalEditOpen, setModalEditOpen] = useState(false);
  
  const [newPotongan, setNewPotongan] = useState({
    noanggota: "",
    potsks: "",
    potsm: "",
    potd2: "",
  });
  
  const [editPotongan, setEditPotongan] = useState({
    noanggota: "",
    potsks: "",
    potsm: "",
    potd2: "",
  });

  useEffect(() => {
    if (isReady) getDataPotongan();
  }, [isReady]);

  const getDataPotongan = async () => {
    try {
      const response = await api.get("/api/setup/simpanansukarela");
      setDataPotongan(response.data || []);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
      alert("Gagal mengambil data potongan sukarela.");
    }
  };

  const handleChange = (e, isEdit = false) => {
    const { name, value } = e.target;
    if (isEdit) {
      setEditPotongan((prev) => ({ ...prev, [name]: value }));
    } else {
      setNewPotongan((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleAdd = async () => {
    try {
      await api.post("/api/setup/simpanansukarela", newPotongan);
      setModalAddOpen(false);
      setNewPotongan({ noanggota: "", potsks: "", potsm: "", potd2: "" });
      getDataPotongan();
    } catch (err) {
      console.error("Gagal menambah data:", err);
      alert("Gagal menambah potongan sukarela: " + (err.response?.data?.message || err.message));
    }
  };

  const handleEdit = async () => {
    try {
      await api.patch(`/api/setup/simpanansukarela/${editPotongan.noanggota}`, editPotongan);
      setModalEditOpen(false);
      getDataPotongan();
    } catch (err) {
      console.error("Gagal mengedit data:", err);
      alert("Gagal mengedit data potongan sukarela: " + (err.response?.data?.message || err.message));
    }
  };

  const handleDelete = async (noanggota) => {
    if (window.confirm(`Yakin ingin menghapus data anggota ${noanggota}?`)) {
      try {
        await api.delete(`/api/setup/simpanansukarela/${noanggota}`);
        getDataPotongan();
      } catch (err) {
        console.error("Gagal menghapus data:", err);
        alert("Gagal menghapus data: " + (err.response?.data?.message || err.message));
      }
    }
  };

  const openAddModal = () => {
    setNewPotongan({ noanggota: "", potsks: "", potsm: "", potd2: "" });
    setModalAddOpen(true);
  };

  const openEditModal = (row) => {
    setEditPotongan({
      noanggota: row.noanggota,
      potsks: row.potsks,
      potsm: row.potsm,
      potd2: row.potd2,
    });
    setModalEditOpen(true);
  };

  const filteredData = dataPotongan.filter(
    (item) =>
      item.noanggota.toLowerCase().includes(searchText.toLowerCase()) ||
      item.nama.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { name: "No", selector: (row, i) => i + 1, width: "60px", center: true },
    { name: "No Anggota", selector: (row) => row.noanggota, sortable: true, center: true },
    { name: "Nama", selector: (row) => row.nama, sortable: true },
    { name: "Pot. SKS", selector: (row) => row.potsks, sortable: true, right: true },
    { name: "Pot. SM", selector: (row) => row.potsm, sortable: true, right: true },
    { name: "Pot. D2", selector: (row) => row.potd2, sortable: true, right: true },
    
    {
      name: "Aksi",
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button className="btn btn-info btn-sm" onClick={() => openEditModal(row)}>
            <i className="fa fa-edit" />
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => handleDelete(row.noanggota)}>
            <i className="fa fa-trash" />
          </button>
        </div>
      ),
      width: "150px",
      center: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "16px",
        backgroundColor: "#f0f0f0",
        borderRight: "2px solid #ddd",
      },
    },
    cells: {
      style: {
        borderRight: "1px solid #ddd",
        padding: "10px 8px",
      },
    },
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="mb-0" style={{ fontSize: "22px" }}>SET POTONGAN SUKARELA</h4>
          <button className="btn btn-primary" onClick={openAddModal}>
            Tambah Data
          </button>
        </div>
      </div>

      <div className="card-body">
        <div className="mb-2 d-flex justify-content-end">
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ maxWidth: "220px" }}
            placeholder="Cari no anggota/nama..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          striped
          dense
          highlightOnHover
          responsive
          customStyles={customStyles}
        />
      </div>

      {/* Modal Tambah */}
      {modalAddOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">TAMBAH POTONGAN SUKARELA</h5>
                <button className="btn-close" onClick={() => setModalAddOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="form-group mb-2">
                  <label>No Anggota</label>
                  <input type="text" name="noanggota" className="form-control"
                    value={newPotongan.noanggota} onChange={handleChange} required />
                </div>
                <div className="form-group mb-2">
                  <label>Pot. SKS</label>
                  <input type="number" name="potsks" className="form-control"
                    value={newPotongan.potsks} onChange={handleChange} />
                </div>
                <div className="form-group mb-2">
                  <label>Pot. SM</label>
                  <input type="number" name="potsm" className="form-control"
                    value={newPotongan.potsm} onChange={handleChange} />
                </div>
                <div className="form-group mb-2">
                  <label>Pot. D2</label>
                  <input type="number" name="potd2" className="form-control"
                    value={newPotongan.potd2} onChange={handleChange} />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModalAddOpen(false)}>Batal</button>
                <button className="btn btn-success btn-sm" onClick={handleAdd}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Edit */}
      {modalEditOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">EDIT POTONGAN SUKARELA</h5>
                <button className="btn-close" onClick={() => setModalEditOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="form-group mb-2">
                  <label>No Anggota</label>
                  <input disabled className="form-control" value={editPotongan.noanggota} />
                </div>
                <div className="form-group mb-2">
                  <label>Pot. SKS</label>
                  <input type="number" name="potsks" className="form-control"
                    value={editPotongan.potsks} onChange={(e) => handleChange(e, true)} />
                </div>
                <div className="form-group mb-2">
                  <label>Pot. SM</label>
                  <input type="number" name="potsm" className="form-control"
                    value={editPotongan.potsm} onChange={(e) => handleChange(e, true)} />
                </div>
                <div className="form-group mb-2">
                  <label>Pot. D2</label>
                  <input type="number" name="potd2" className="form-control"
                    value={editPotongan.potd2} onChange={(e) => handleChange(e, true)} />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModalEditOpen(false)}>Batal</button>
                <button className="btn btn-success btn-sm" onClick={handleEdit}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetPotSukarela;
